<template>
	<div class="index">
		<van-tabs v-model="kemu" @change="event_changeKemu" color="#2cd5ff" line-width="50%" title-active-color="#2cd5ff">
			<van-tab title="科目一" name="1"></van-tab>
			<van-tab title="科目四" name="4"></van-tab>
		</van-tabs>
		<van-swipe :autoplay="3000" height="120" class="swipe">
			<van-swipe-item v-for="(image, index) in attachments" :key="index">
				<img class="swipe-image" v-lazy="image.image" @click="event_adv(image)"/>
			</van-swipe-item>
		</van-swipe>
		<van-tabs v-model="cartype" swipe-threshold="4" class="index-tabs-group" @change="event_changeCartype">
			<van-tab v-for="(item,index) in dlicensecate" :key="index" :name="item.id" title-class="tabs">
				<template #title> <van-icon :name="item.icon" class-prefix="icon" class="iconfontt"/>{{item.subject}}</template>
			</van-tab>
		</van-tabs>

		<van-overlay :show="state_kefu" @click="state_kefu = false" >
			<div class="wrapper">
				<img style="max-width:80%;max-height:80vh" :src="kefu.image"/>
			</div>
		</van-overlay>

		<van-row type="flex" justify="center" class="btn-group">
			<van-col span="7">
				<div class="btn left">
					<router-link :to="{path:'/fee',query:{qcolumn:kemu == 4 ? 2 : kemu,cartype:cartype,subject_type:'rand'}}">
						<i class="iconfont icon-suiji"></i>
						顺序练习
					</router-link>
				</div>
				<div class="btn left">
					<router-link :to="{path:'/fee'}">
						<i class="iconfont icon-lianxi_"></i>
						技巧练习
					</router-link>
				</div>
				<div class="btn left">
					<router-link :to="{path:'/chapter',query:{qcolumn:kemu == 4 ? 2 : kemu,cartype:cartype}}">
						<i class="iconfont icon-zhangjielianxi"></i>
						章节练习
				    </router-link>
				</div>
				<div class="btn left">
					<router-link :to="{path:'/videocourse',query:{kemu:kemu == 4 ? 2 : kemu}}" style="color: inherit;">
					    <i class="iconfont icon-kechengxingshi"></i>
					    视频课程
					</router-link>
				</div>
			</van-col>
			<van-col span="10">
				<div class="btn center">
					<router-link :to="{path:'/learn',query:{qcolumn:kemu == 4 ? 2 : kemu,cartype:cartype,subject_type:'learn'}}">
						<svg width="100" height="100" class="svg-btn" >
							<defs>
								<linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
									<stop offset="0%" style="stop-color:#dae5fe;stop-opacity:1" />
									<stop offset="100%" style="stop-color:#e3cff9;stop-opacity:1" />
								</linearGradient>
								<linearGradient id="grad2" x1="-30%" y1="0%" x2="30%" y2="100%">
									<stop offset="0%" style="stop-color:#7943ea;stop-opacity:1" />
									<stop offset="100%" style="stop-color:#9bd1fd;stop-opacity:1" />
								</linearGradient>
								<radialGradient id="grad3" cx="35%" cy="40%" r="50%" fx="20%" fy="35%" fr="5%">
									<stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.4"></stop>
									<stop offset="100%" style="stop-color:#ffffff;stop-opacity:0"></stop>
								</radialGradient>
							</defs>
							<circle r="48" cy="50" cx="50" stroke-width="4" stroke="url(#grad1)" stroke-linejoin="round" stroke-linecap="round" fill="none"/>
							<circle class="progress" r="48" cy="50" cx="50" stroke-width="4" stroke="#9a72fa" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-dashoffset="340px"  stroke-dasharray="340px" >
								<animate attributeName="stroke-dashoffset" begin="0s" dur="1.5s" from="340" to="340" fill="freeze" repeatCount="1" />
							</circle>
							<circle cx="50" cy="50" r="45" fill="#FFFFFF" stroke-width="15"></circle>
							<circle cx="50" cy="50" r="42" fill="url(#grad2)" stroke-width="15"></circle>
							<circle cx="40" cy="40" r="22" fill="url(#grad3)" stroke-width="15"></circle>
							<text x="50" y="45" font-size="14" text-anchor="middle" fill="#FFFFFF">精选{{number}}题</text>
							<text x="50" y="65" font-size="12" text-anchor="middle" fill="#FFFFFF">不过包赔</text>
						</svg>
					</router-link>
				</div>
				<div class="btn center">
					<router-link :to="{path:'/fee',query:{subject_type:'ai'}}">
						<svg width="100" height="100" class="svg-btn">
							<defs>
								<linearGradient id="grad4" x1="0%" y1="0%" x2="0%" y2="100%">
									<stop offset="0%" style="stop-color:#faebb8;stop-opacity:1" />
									<stop offset="100%" style="stop-color:#ffc8c6;stop-opacity:1" />
								</linearGradient>
								<linearGradient id="grad5" x1="-30%" y1="0%" x2="30%" y2="100%">
									<stop offset="0%" style="stop-color:#eeb730;stop-opacity:1" />
									<stop offset="100%" style="stop-color:#ff8798;stop-opacity:1" />
								</linearGradient>
								<radialGradient id="grad6" cx="35%" cy="40%" r="50%" fx="20%" fy="35%" fr="5%">
									<stop offset="0%" style="stop-color:#ffffff;stop-opacity:0.4"></stop>
									<stop offset="100%" style="stop-color:#ffffff;stop-opacity:0"></stop>
								</radialGradient>
							</defs>
							<circle r="48" cy="50" cx="50" stroke-width="4" stroke="url(#grad4)" stroke-linejoin="round" stroke-linecap="round" fill="none"/>
							<circle class="progress" r="48" cy="50" cx="50" stroke-width="4" stroke="#9a72fa" stroke-linejoin="round" stroke-linecap="round" fill="none" stroke-dashoffset="340px"  stroke-dasharray="340px" >
								<animate attributeName="stroke-dashoffset" begin="0s" dur="1.5s" from="340" to="340" fill="freeze" repeatCount="1" />
							</circle>
							<circle cx="50" cy="50" r="45" fill="#FFFFFF" stroke-width="15"></circle>
							<circle cx="50" cy="50" r="42" fill="url(#grad5)" stroke-width="15"></circle>
							<circle cx="40" cy="40" r="22" fill="url(#grad6)" stroke-width="15"></circle>
							<text x="50" y="45" font-size="14" text-anchor="middle" fill="#FFFFFF">AI出题</text>
							<text x="50" y="65" font-size="12" text-anchor="middle" fill="#FFFFFF">易错题</text>
						</svg>
					</router-link>
				</div>
			</van-col>
			<van-col span="7">
				<div class="btn right">
					<router-link :to="{path:'/fee',query:{qcolumn:kemu == 4 ? 2 : kemu,cartype:cartype,subject_type:'exam'}}">
						<i class="iconfont icon-jiaxiao"></i>
						模拟考试
					</router-link>
				</div>
				<div class="btn right">
					<router-link :to="{path:'/fee',query:{subject_type:'mf'}}">
						<i class="iconfont icon-bofangzhong"></i>
						满分学习
					</router-link>
				</div>
				<div class="btn right">
					<router-link to="/wrong">
						<i class="iconfont icon-bangzhu"></i>
						我的错题
					</router-link>
				</div>
				<div class="btn right">
					<router-link to="/compensate">
						<i class="iconfont icon-zhengce"></i>
						科目一保过卡
					</router-link>
				</div>
			</van-col>
		</van-row>
		<div class="popup_index" v-if="showFollow && 0">
		  <div class="popup_mask" @click="closeFollow"></div>
		  <div class="popup_content">
			<div class="popup_title">您尚未关注公众号</div>
			<div class="popup_code">
			  <img src="../assets/ewm.png" style="pointer-events:all" alt="">
			</div>
			<p>为了方便找到我们,请长按二维码关注公众号</p>
		  </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Index',
		data() {
			return {
				showFollow: false,
				kemu:1,
				attachments:[],
				kefu:{},
				number:'',
				state_kefu:false,
				dlicensecate:[],
				cartype:null,
				jingxuan_r_rate:0,
				jingxuan_rate:20,
				text:'fds'
			}
		},
		created(){
			this.isFollow();
			this.$https.post('/api/adv/indexnew.html', this.$qs.stringify({
				token: this.$store.state.token,
				newindex:1
			})).then((res) => {
				//this.marker = res.data.data.marker;
				if (res.data.data.kefu && res.data.data.kefu.image) {
					this.kefu = res.data.data.kefu;
					this.state_kefu = true;
				}
				//this.compenstateList = res.data.data.compenstateList;
				this.advList = res.data.data.advList;
				this.attachments = res.data.data.advList.adv_1.attachments;
				this.dlicensecate = res.data.data.dlicensecate;
				for(var n in this.dlicensecate){
					this.cartype = this.dlicensecate[n].id;
					break;
				}
				this.loadNumber();
			});
		},
		methods:{
			closeFollow(){
				var that=this;
				that.showFollow = false;
			},
			/**
			 * 是否关注公众号
			 */
			isFollow() {
				var that = this;
				this.$app.pr('/api/user/isfollow.html').then((res) => {
					if (res.data.subscribe == 0) {
						that.showFollow = true;
					}
				}, (res) => {
					console.log(res)
				})
			},
			//精选六百题
			loadNumber(){
				this.$https.post('/api/adv/indexnewnumber.html', this.$qs.stringify({
					token: this.$store.state.token,
					qcolumn_id:this.kemu == 4 ? 2 : this.kemu,
					cartype:this.cartype
				})).then((res) => {
					this.number = res.data.data.count;
				});
			},
			//切换车型
			event_changeCartype(el){
				this.loadNumber()
			},
			//切换科目
			event_changeKemu(el){
				this.loadNumber()
			},
			//广告点击
			event_adv(item){
				if(item.url){
					window.location.href = url;
				}
			},
		}
	}
</script>
<style scoped>
	.swipe{
		margin-top:5px;
	}
	.swipe-image{
		width:100%;
		height:120px;
	}
	.btn-group .btn{
		text-align:center;
		font-size:14px;
	}
	.progress{
		transform:rotate(-90deg);
		transform-origin:50px 50px;
	}
	.btn-group .btn i{
		display:block;
		font-size:18px;
		width:12vw;
		height:12vw;
		margin:auto;
		line-height:12vw;
		border-radius:10vw;
		color:#FFFFFF;
	}
	.btn-group .btn.left:first-child i{
		background: -webkit-gradient(linear,left bottom,left top,from(#a44dfd),to(#e9a9fe));
		background: linear-gradient(0deg,#a44dfd,#e9a9fe);
	}
	.btn-group .btn.left:nth-child(2) i{
		background: -webkit-gradient(linear,left bottom,left top,from(#fb601c),to(#fc9b67));
		background: linear-gradient(0deg,#fb601c,#fc9b67);
	}
	.btn-group .btn.left:nth-child(3) i{
		background: -webkit-gradient(linear,left bottom,left top,from(#26c9d8),to(#68f1f6));
		background: linear-gradient(0deg,#26c9d8,#68f1f6);
	}
	.btn-group .btn.left:nth-child(4) i{
		background: -webkit-gradient(linear,left bottom,left top,from(#e9b018),to(#ffe259));
		background: linear-gradient(0deg,#e9b018,#ffe259);
	}
	.btn-group .btn.right:first-child i{
		background: -webkit-gradient(linear,left bottom,left top,from(#fd426b),to(#fd7290));
		background: linear-gradient(0deg,#fd426b,#fd7290);
	}
	.btn-group .btn.right:nth-child(2) i{
		background: -webkit-gradient(linear,left bottom,left top,from(#1b5cf3),to(#a7aeff));
		background: linear-gradient(0deg, #1b5cf3, #a7aeff);
	}
	.btn-group .btn.right:nth-child(3) i{
		background: -webkit-gradient(linear,left bottom,left top,from(#e93a3a),to(#fd8585));
		background: linear-gradient(0deg,#e93a3a,#fd8585);
	}
	.btn-group .btn.right:nth-child(4) i{
		background: -webkit-gradient(linear,left bottom,left top,from(#15d184),to(#49efa7));
		background: linear-gradient(0deg,#15d184,#49efa7);
	}
	.btn-group .btn.left,.btn-group .btn.right{
		height:22vw;
		padding-top:3vw;
	}
	.btn-group .btn.center{
		height:50%;
		display:flex;
		align-items: center;
	}
	.btn-group .btn.center > div{
		flex:1;
	}
	.btn-group .btn.center > a{
		margin:auto;
	}
	.btn-group .btn.center a{
		width:26vw;
		height:26vw;
		display:inline-block;
		border-radius:15vw;
	}
	
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}
	.van-overlay{
		z-index:10;
	}
	.van-tab.tabs .iconfontt{
		font-size:4vw;
		margin-right:5px;
	}
	.btn-group{
		margin-top:5px;
		background-color:#FFFFFF;
		box-shadow:0px 0px 4px #DDDDDD;
	}
</style>
<style>
	.index-tabs-group{
		padding:10px 0px;
		background-color:#FFFFFF;
	}
	.index-tabs-group .tabs{
		border:1px solid #EEEEEE;
		border-radius:10px;
		margin-left:10px;
	}
	.index-tabs-group .tabs:first-child{
		margin-left:0px;
	}
	.index-tabs-group .van-tabs__wrap{
		height:35px;
	}
	.index-tabs-group .van-tab.van-tab--active.tabs{
		background-color:#e3f9ff;
		color:#2cd5ff;
	}
	.index-tabs-group .van-tab.van-tab--active.tabs .iconfontt{
		font-size:4vw;
		margin-right:5px;
	}
	.index-tabs-group .van-tabs__line{
		display:none;
	}
	.index{
		padding-bottom:50px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue